/* eslint-disable */

<template>
  <div class="flex flex-col items-center relative bg-dark main-border rounded-lg">
    <div class="flex p-6 w-full">
      <div class="flex flex-col w-1/4 main-border rounded-lg overflow-hidden bg-dark z-10">
        <span class="flex justify-center text-black text-lg font-bold px-4 py-1 w-full" style="background-color: #cd93fd"
          >QA & SW Testing Tailnet</span
        >

        <div class="flex flex-col gap-y-4 p-4">
          <div
            v-for="(endpoint, index) in endpoints"
            v-if="index < 3"
            class="flex flex-col main-border rounded-lg overflow-hidden transition duration-300"
            :id="'endpoint' + index"
          >
            <span
              class="flex items-center justify-center gap-x-2 p-2 main-bottom-border cursor-pointer"
              @click="handleEndpointClick(index)"
            >
              <font-awesome-icon icon="fa-regular fa-microchip" class="h-6 w-6 text-white" />
              <h4>{{ endpoint.ip }}</h4>
            </span>

            <span class="flex items-center gap-x-1 px-2 py-1 main-bottom-border">
              <input
                type="checkbox"
                v-model="endpoint.selected"
                class="checkbox border border-borderColor"
                :style="{ backgroundColor: endpoint.selected === 'clean' ? '#76af64' : '#040916' }"
                @change="handleChange('clean', index)"
              />
              <p style="color: #76af64">ENDPOINT IS CLEAN</p>
            </span>

            <span class="flex items-center gap-x-1 px-2 py-1 main-bottom-border">
              <input
                type="checkbox"
                v-model="endpoint.selected"
                class="checkbox border border-borderColor"
                :style="{ backgroundColor: endpoint.selected === 'infected' ? '#c36b6e' : '#040916' }"
                @change="handleChange('infected', index)"
              />
              <p style="color: #c36b6e">ENDPOINT IS INFECTED</p>
            </span>

            <span class="flex items-center gap-x-1 px-2 py-1">
              <input
                type="checkbox"
                v-model="endpoint.selected"
                class="checkbox border border-borderColor"
                :style="{ backgroundColor: endpoint.selected === 'source' ? '#c3984e' : '#040916' }"
                @change="handleChange('source', index)"
              />
              <p style="color: #c3984e">ENDPOINT IS SOURCE</p>
            </span>
          </div>

          <div class="flex flex-col main-border rounded-lg p-2">
            <div class="flex items-center gap-x-2">
              <img
                src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/249739812367248924/tailscale-logo.png"
                width="20px"
                height="20px"
                draggable="false"
              />
              <span class="flex items-center gap-x-2"><p class="text-grey">TS Exit Node - US-PS-01</p></span>
            </div>

            <div class="flex items-center justify-between mt-2">
              <font-awesome-icon icon="fa-regular fa-wave-pulse" class="h-6 w-6 mr-2 text-white" />

              <span class="flex items-center gap-x-1 main-border rounded-lg px-2 py-1">
                <font-awesome-icon icon="fa-regular fa-wifi" class="h-5 w-5 mr-2 text-white" />
                <p class="font-semibold">EN: 10.10.10.0/24</p>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col relative items-center justify-between w-3/5">
        <hr
          class="border-primary"
          style="
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            flex: 0 0 auto;
            height: 55%;
            border-left-width: 0.5rem;
            bottom: 4.7rem;
          "
        />

        <div class="flex items-center justify-center">
          <lottie-animation
            path="https://connect-cdn.intellectualpoint.com/assets/lotties/internet-pulse.json"
            :loop="true"
            :autoPlay="true"
            :speed="1"
            :width="300"
          />
        </div>

        <div class="flex flex-col main-border rounded-lg overflow-hidden bg-dark z-10">
          <span class="flex justify-center text-white text-lg font-bold px-4 py-1 w-full bg-primary">WireGuard Gateway Zone</span>

          <div class="py-8 px-16">
            <div class="flex flex-col gap-y-3 items-center main-border rounded-lg p-3">
              <p class="text-primary">US-EAST-1 | IAD | PING: 71ms</p>

              <img
                src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/249739812367248924/tailscale-full-logo.png"
                width="100%"
                height="35px"
                draggable="false"
              />

              <span class="flex items-center gap-x-2 px-2 py-1 main-border rounded-lg">
                <font-awesome-icon icon="fa-regular fa-shield" class="h-5 w-5 text-white" />
                <h4>ACL - Authn/Authz</h4>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col main-border w-1/4 rounded-lg overflow-hidden bg-dark z-10">
        <span class="flex justify-center text-black text-lg font-bold px-4 py-1 w-full" style="background-color: #a2ff97"
          >Git DevOps CI/CD Tailnet</span
        >

        <div class="flex flex-col gap-y-4 p-4">
          <div
            v-for="(endpoint, index) in endpoints"
            v-if="index > 2"
            class="flex flex-col main-border rounded-lg overflow-hidden transition duration-300"
            :id="'endpoint' + index"
          >
            <span
              class="flex items-center justify-center gap-x-2 p-2 main-bottom-border cursor-pointer"
              @click="handleEndpointClick(index)"
            >
              <font-awesome-icon icon="fa-regular fa-microchip" class="h-6 w-6 text-white" />
              <h4>{{ endpoint.ip }}</h4>
            </span>

            <span class="flex items-center gap-x-1 px-2 py-1 main-bottom-border">
              <input
                type="checkbox"
                v-model="endpoint.selected"
                class="checkbox border border-borderColor"
                :style="{ backgroundColor: endpoint.selected === 'clean' ? '#76af64' : '#040916' }"
                @change="handleChange('clean', index)"
              />
              <p style="color: #76af64">ENDPOINT IS CLEAN</p>
            </span>

            <span class="flex items-center gap-x-1 px-2 py-1 main-bottom-border">
              <input
                type="checkbox"
                v-model="endpoint.selected"
                class="checkbox border border-borderColor"
                :style="{ backgroundColor: endpoint.selected === 'infected' ? '#c36b6e' : '#040916' }"
                @change="handleChange('infected', index)"
              />
              <p style="color: #c36b6e">ENDPOINT IS INFECTED</p>
            </span>

            <span class="flex items-center gap-x-1 px-2 py-1">
              <input
                type="checkbox"
                v-model="endpoint.selected"
                class="checkbox border border-borderColor"
                :style="{ backgroundColor: endpoint.selected === 'source' ? '#c3984e' : '#040916' }"
                @change="handleChange('source', index)"
              />
              <p style="color: #c3984e">ENDPOINT IS SOURCE</p>
            </span>
          </div>

          <div class="flex flex-col main-border rounded-lg p-2">
            <div class="flex items-center gap-x-2">
              <img
                src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/security-plus/249739812367248924/tailscale-logo.png"
                width="20px"
                height="20px"
                draggable="false"
              />
              <span class="flex items-center gap-x-2"><p class="text-grey">TS Exit Node - US-CT-01</p></span>
            </div>

            <div class="flex items-center justify-between mt-2">
              <font-awesome-icon icon="fa-regular fa-wave-pulse" class="h-6 w-6 mr-2 text-white" />

              <span class="flex items-center gap-x-1 main-border rounded-lg px-2 py-1">
                <font-awesome-icon icon="fa-regular fa-wifi" class="h-5 w-5 mr-2 text-white" />
                <p class="font-semibold">EN: 10.60.0.0/24</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="absolute flex justify-center w-3/4 border-primary" style="bottom: 4.7rem; border-top-width: 0.5rem" />

    <movable-popup
      refVal="endpointLogPopup"
      :title="endpoints[endpointSelected].ip + ' Logs - Click Here to Drag This Popup'"
      :active="endpointPopupActive"
      v-on:close="endpointPopupActive = false"
    >
      <template v-slot:content>
        <div v-html="logs[endpointSelected]" class="rounded-lg" style="color: #1db939" />
      </template>
    </movable-popup>
  </div>
</template>

<script>
import Prism from 'vue-prism-component';
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';
import LottieAnimation from '../../../../../../../../components/lottie/LottieAnimation';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      endpointPopupActive: false,
      endpointSelected: 0,

      endpoints: [
        {
          ip: '10.10.10.189',
          answer: '',
          selected: '',
        },
        {
          ip: '10.10.10.192',
          answer: '',
          selected: '',
        },
        {
          ip: '10.10.10.114',
          answer: '',
          selected: '',
        },
        {
          ip: '10.10.10.189',
          answer: '',
          selected: '',
        },
        {
          ip: '10.10.10.192',
          answer: '',
          selected: '',
        },
        {
          ip: '10.10.10.114',
          answer: '',
          selected: '',
        },
      ],

      logs: ['TEST', ''],
    };
  },
  methods: {
    markSimulation() {
      let total_score = 0;

      this.endpoints.map((endpoint, index) => {
        if (endpoint.answer === endpoint.selected) {
          total_score += 1;
        } else {
          const element = document.getElementById(`endpoint${index}`);
          if (element) {
            element.classList.add('incorrect');
          }
        }
      });

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score);
      } else {
        this.$emit('simulation_getting_there', total_score);
      }
    },

    handleEndpointClick(index) {
      this.endpointSelected = index;
      this.endpointPopupActive = true;
    },

    handleChange(selection, index) {
      const element = document.getElementById(`endpoint${index}`);
      if (element) {
        element.classList.remove('incorrect');
      }
      if (this.endpoints[index].selected === selection) {
        this.endpoints[index].selected = '';
      } else {
        this.endpoints[index].selected = selection;
      }
    },
  },
  components: {
    Prism,
    vSelect,
    MovablePopup,
    LottieAnimation,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.checkbox {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #000;
  background-color: transparent;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  margin-right: 8px;
  position: relative;
}

.incorrect {
  border: 1px solid #c36b6e !important;
}
</style>
